export default "<h1> Portal - Device Browser </h1>\r\n<p> Provides an aggregated overview of the Device Browsers that were detected.</p>\r\n\r\n\r\n\r\n";